import { logEvent } from '@/utils/analytics';
import type { MouseEventHandler } from 'react';
import { default as NextLink } from 'next/link';
import Events from '@/utils/amplitudeEvents.json';
import { getLinkType } from '@/utils/getLinkType';
import { isBusinessRoute } from '@/utils/business-route';
import { type ButtonProps, Button } from '@zopauk/web-ui';
import { getAnalyticsIds, pushToDataLayer } from '@/utils/gtm';

type ButtonLinkProps = {
  logEventProperties?: Record<string, unknown>;
  eventType?: string;
} & ButtonProps<typeof NextLink>;

export const ButtonLink = ({
  eventType = Events.LINK_CLICK,
  logEventProperties = {},
  href,
  ...buttonProps
}: ButtonLinkProps) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (buttonProps.onClick) {
      buttonProps.onClick(event);
    }

    logEvent(eventType, {
      link_type: getLinkType(href?.toString() ?? ''),
      text: buttonProps.children?.toString(),
      currentPage: window.location.href,
      target: buttonProps.target,
      type: 'button-link',
      href,
      ...(isBusinessRoute(window.location.pathname) && { user_type: 'b2b' }),
      ...logEventProperties,
    });

    pushToDataLayer({ page_location: window.location.href, event: 'cta_click', ...getAnalyticsIds() });
  };

  return <Button onClick={handleClick} data-href={href} as={NextLink} href={href} {...buttonProps} />;
};
